import type { PostProcessorModule } from "i18next";

const NO_BREAK_SPACE = "\u00a0";

export const applyFrenchTypography = (text: string): string =>
  text.replace(/«\s+/g, `«${NO_BREAK_SPACE}`).replace(/\s+»/g, `${NO_BREAK_SPACE}»`);

export const FRENCH_TYPOGRAPHY_POST_PROCESSOR = "frenchTypography";

export const frenchTypographyPostProcessor: PostProcessorModule = {
  type: "postProcessor",
  name: FRENCH_TYPOGRAPHY_POST_PROCESSOR,
  process: (value: string) => (typeof value === "string" ? applyFrenchTypography(value) : value),
};
